import { BeanMotivo } from "./BeanMotivo";
import { BeanUsuario } from "./BeanUsuario";

export class BeanParametroXMotivoMoni {
    constructor(
        public mopmIdCdMotivoParametroMoni: number,
        public mopmDhRegistro: string ,
        public pamoIdCdParametroFormulario: number,
        public motiIdCdMotivo: number,
        public usuaIdCdUsuario: number,
        public motive : BeanMotivo,
        public user : BeanUsuario,

    ){}
}

